export const tableStrings = {
  sortAsc: 'Aufsteigend sortieren',
  sortDesc: 'Absteigen sortieren',
  noSort: ' Sortierung aufheben',
  sortStatusAsc: 'Aufsteigend sortiert',
  sortStatusDesc: 'Absteigend sortiert',
  descending: 'absteigend',
  ascending: 'aufsteigend',
  messages: {
    loading: 'Daten werden geladen...',
    loadingMore: 'Weitere Daten werden geladen...',
    noData: 'Keine Daten verfügbar',
    filterBy: (columnName: string) => `Filtern nach ${columnName}`,
    tableSortedBy: (direction: string, columnName: string) =>
      `Tabelle sortiert nach ${columnName}, ${direction}`,
    tableSortCleared: 'Tabellensortierung aufgehoben',
    errorGeneric: 'Es ist ein Fehler aufgetreten',
    globalSearch: 'Suche...',
    globalSearchSubmit: 'Suche',
    globalSearchClear: 'Suche leeren',
    totalCount: (count: number, label: string) =>
      `${count.toLocaleString('de-DE')} ${label}`,
  },
  entity: {
    singular: 'Eintrag',
    plural: 'Einträge',
  },
  filter: {
    filterBy: (columnName: string) => `Filter: ${columnName}`,
    apply: 'Anwenden',
    clear: 'Löschen',
    clearAll: 'Alle Filter zurücksetzen',
    from: 'Von',
    to: 'Bis',
    since: (value: string) => `ab ${value}`,
    until: (value: string) => `bis ${value}`,
    selectPlaceholder: 'Auswählen...',
    selectedItemsLabel: '{0} Elemente ausgewählt',
    emptyOptionLabel: '(leer)',
    optionsLoading: 'Auswahlwerte werden geladen...',
    columnSearchPlaceholder: 'Spalte suchen…',
    noColumnFound: 'Keine Spalte gefunden',
    addValue: 'Wert hinzufügen',
    removeValue: (value: string) => `${value} entfernen`,
    addText: (text: string) => `„${text}“ hinzufügen`,
    searchPlaceholder: 'Suchen…',
    searchOrAddPlaceholder: 'Suchen oder Text eingeben…',
    noMoreValues: 'Keine weiteren Werte',
    moreValuesHint: 'Weitere Werte vorhanden – Suche eingrenzen',
    unusedOptionHint:
      'Grau: kein Vorgang mit diesem Wert bei den aktuellen Filtern',
  },
  tableView: {
    name: 'Name',
    showColumns: 'Spalten anzeigen',
    columnOrder: 'Spaltenreihenfolge',
    columnsConfig: 'Spalten & Reihenfolge',
    searchColumns: 'Spalten suchen...',
    showSelectedOnly: 'Nur ausgewählte anzeigen',
    noColumnsFound: 'Keine passenden Spalten gefunden',
    manageViews: 'Ansichten verwalten',
    changeViews: 'Ansichten ändern',
    createNewView: 'Neue Ansicht erstellen',
    addColumn: 'Spalte hinzufügen',
    standardView: 'Standardansicht',
    saveAsNew: 'Als neue Ansicht speichern',
    selectView: 'Ansicht auswählen',
    filtersConfig: 'Filter & Sortierung',
    applyActiveFilters: 'Aktuelle Filter und Sortierung übernehmen',
    columnFiltersHint:
      'Filter je Spalte über das Filtersymbol in der Spaltenliste festlegen.',
    filterMode: {
      label: 'Filter verknüpfen',
      and: 'Alle Filter müssen zutreffen (UND)',
      or: 'Mindestens ein Filter muss zutreffen (ODER)',
    },
    activeFilterCount: (count: number) =>
      count === 1 ? '1 Filter aktiv' : `${count} Filter aktiv`,
    resetView: {
      label: 'Zurücksetzen',
      title: 'Auf Standard zurücksetzen',
      header: 'Ansicht zurücksetzen',
      confirmResetMessage: (viewName: string) =>
        `Möchten Sie Ihre Anpassungen an der Ansicht "${viewName}" verwerfen?`,
    },
    deleteView: {
      header: 'Ansicht löschen',
      confirmDeleteMessage: (viewName: string) =>
        `Möchten Sie die Ansicht "${viewName}" wirklich löschen?`,
    },
  },
  layout: {
    fit: 'An Tabellenbreite anpassen',
    scroll: 'Horizontales Scrollen',
    autoFitAll: 'Spaltenbreiten anpassen',
    autoFitAllTooltip:
      'Alle Spaltenbreiten automatisch an den breitesten sichtbaren Inhalt anpassen',
  },
};
